import { render } from "./KpiSection.vue?vue&type=template&id=780684dd&ts=true"
import script from "./KpiSection.vue?vue&type=script&lang=ts"
export * from "./KpiSection.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__